import React from 'react'

const Header = () => {
  return (
    <header>
      <div className="logo-lockup">
        <div className="logo-svg-wrap">
          <div className="logo-glow-ring"></div>
          <svg width="72" height="72" viewBox="0 0 72 72" fill="none">
            <circle cx="36" cy="36" r="34" fill="#0d1117" stroke="url(#bg1)" strokeWidth="1.5"/>
            <path d="M36 16C28 16 20 26 20 36C20 46 26 56 36 58C46 56 52 46 52 36C52 26 44 16 36 16Z" fill="url(#bg2)" opacity=".95"/>
            <ellipse cx="30" cy="26" rx="5" ry="7" fill="white" opacity=".12" transform="rotate(-15 30 26)"/>
            <path d="M27 34Q36 31 45 34" stroke="rgba(255,255,255,.15)" strokeWidth="1" fill="none" strokeLinecap="round"/>
            <path d="M25 40Q36 37 47 40" stroke="rgba(255,255,255,.10)" strokeWidth="1" fill="none" strokeLinecap="round"/>
            <path d="M30 16C26 8 18 7 16 12C14 17 20 20 26 17C24 22 22 26 24 28C26 24 30 20 30 16Z" fill="url(#bg3)" opacity=".95"/>
            <path d="M36 14C36 6 30 3 28 7C26 11 30 15 36 14Z" fill="url(#bg4)" opacity=".9"/>
            <path d="M42 16C46 8 54 7 56 12C58 17 52 20 46 17C48 22 50 26 48 28C46 24 42 20 42 16Z" fill="url(#bg3)" opacity=".95"/>
            <line x1="23" y1="44" x2="29" y2="44" stroke="rgba(99,179,237,.5)" strokeWidth="1" strokeDasharray="2,1"/>
            <line x1="43" y1="44" x2="49" y2="44" stroke="rgba(99,179,237,.5)" strokeWidth="1" strokeDasharray="2,1"/>
            <text x="36" y="47" textAnchor="middle" fontFamily="Space Mono,monospace" fontSize="11" fontWeight="700" fill="white" opacity=".9">AI</text>
            <circle cx="36" cy="13" r="2.5" fill="url(#bg5)" opacity=".9"/>
            <circle cx="20" cy="19" r="1.5" fill="#52c788" opacity=".7"/>
            <circle cx="52" cy="19" r="1.5" fill="#52c788" opacity=".7"/>
            <defs>
              <linearGradient id="bg2" x1="36" y1="16" x2="36" y2="58" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#ff6b9d"/><stop offset="50%" stopColor="#ff4d6d"/><stop offset="100%" stopColor="#cc2244"/>
              </linearGradient>
              <linearGradient id="bg3" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#52c788"/><stop offset="100%" stopColor="#2d9e60"/></linearGradient>
              <linearGradient id="bg4" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#68d391"/><stop offset="100%" stopColor="#38a169"/></linearGradient>
              <linearGradient id="bg1" x1="0" y1="0" x2="72" y2="72" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#ff4d6d" stopOpacity=".6"/><stop offset="50%" stopColor="#ff8c42" stopOpacity=".3"/><stop offset="100%" stopColor="#52c788" stopOpacity=".4"/>
              </linearGradient>
              <radialGradient id="bg5"><stop offset="0%" stopColor="#fff"/><stop offset="100%" stopColor="#ff8c42"/></radialGradient>
            </defs>
          </svg>
        </div>
        <div className="logo-text-block">
          <div className="logo-name-cn">萝卜AI个人网</div>
          <div className="logo-name-en">LUOBO · AI NAVIGATOR</div>
          <div className="logo-tagline">持续更新 · 精选收录</div>
        </div>
      </div>
      <p className="site-sub">汇聚 AI 工具、书籍、电影与教程 · 开启智能时代的学习旅程</p>
    </header>
  )
}

export default Header
